"use strict";

exports.__esModule = true;
exports["default"] = exports.FeaturedToutContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["body", "footer", "title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** Tout body content */
  body: _propTypes.node,

  /** Tout footer content */
  footer: _propTypes.node,

  /** Title content */
  title: _propTypes.node
};
/**
 * FeaturedToutContent is a generic grouping of content that includes a title,
 * body, and footer. The component is used in both the FeaturedTout and FeaturedTout2.
 */

var FeaturedToutContent = function FeaturedToutContent(_ref) {
  var body = _ref.body,
      footer = _ref.footer,
      title = _ref.title,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, props, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    fontSize: 4,
    fontWeight: 2,
    mb: 1,
    tag: "h5"
  }, title), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "text-mid",
    fontSize: 2,
    lineHeight: "1.3",
    mb: 0
  }, body), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    mt: 1
  }, footer));
};

exports.FeaturedToutContent = FeaturedToutContent;
FeaturedToutContent.propTypes = propTypes;
var _default = FeaturedToutContent;
exports["default"] = _default;